<template>
	<div class="card">
		<div class="card-body">
			<h5>
				<i class="fas fa-layer-group" aria-hidden="true"></i>
				Listado certificados
			</h5>
			<p class="card-title-desc">
				A continuación veras el listado de certificados disponibles.<br />
				Recuerda que solo se visualizaran los certificados de los cursos
				que tengas disponibles.
			</p>
			<v-client-table
				:data="jsonCertificado"
				:columns="columns"
				:options="options"
				v-if="jsonCoordinadora.privilegios"
			>

				<a
					slot="nombreCertificado"
					slot-scope="props"
					href="javascript:void(0)"
					v-b-modal.modal-viewCertificado
					@click="modalCertificado(props)"
				>
					{{ props.row.nombreCertificado }}
				</a>
				
				<div slot="curso" slot-scope="props">
					<div
						v-for="itemCurso in props.row.curso"
						:key="itemCurso.key"
					>
						<div v-if="checkPrivilegio(itemCurso.idPrograma)">
							<a
								href="javascript:void(0)"
								v-b-modal.modal-editCursoCertificado
								@click="modalEditCurso(itemCurso)"
							>
								{{
									itemCurso.nombre
										? itemCurso.nombre
										: itemCurso.tituloCurso
								}}
							</a>
						</div>
						<div v-else>
							{{
								itemCurso.nombre
									? itemCurso.nombre
									: itemCurso.tituloCurso
							}}
						</div>
					</div>
				</div>

				<div slot="estado" slot-scope="propsCertificado">
					<div
						v-for="cursoItem in propsCertificado.row.curso"
						:key="cursoItem.key"
					>
				
						<div v-if="checkPrivilegio(cursoItem.idPrograma)">
							<b-button
								v-b-modal.modal-editCertificado
								@click="modalOpcion(propsCertificado)"
							>
								Editar Certificado
							</b-button>
						</div>
						<div v-else>
							<b-alert :show="true" fade variant="warning"
								>No tienes permisos necesarios.
							</b-alert>
						</div>
					</div>
				</div>
			</v-client-table>
			<PuSkeleton v-else :count="5"></PuSkeleton>
		</div>
		<editCertificado ref="editCertificado" />
		<viewCertificado ref="viewCertificado" />
		<editCursoCertificado ref="editCursoCertificado" />
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import editCertificado from "@/components/certificado/modal/editCertificado";
import viewCertificado from "@/components/certificado/modal/viewCertificado";
import editCursoCertificado from "@/components/certificado/modal/editCursoCertificado";
export default {
	components: {
		editCertificado,
		viewCertificado,
		editCursoCertificado,
	},
	data() {
		return {
			columns: ["idCertificado", "nombreCertificado", "curso", "estado"],
			tableData: [],
			options: {
				headings: {
					idCertificado: "#",
					nombreCertificado: "Nombre Certificado",
					curso: "Asociado en",
					estado: "Opcion",
				},
				sortable: ["nombreCertificado", "asociado"],
				filterable: ["nombreCertificado", "asociado"],
			},
			selectCertificado: "",
		};
	},
	computed: {
		...mapState("certificado", ["jsonCertificado"]),
		...mapState("certificado", ["jsonInstanciaCertificado"]),
		...mapState("alumno", ["jsonCoordinadora"]),
	},
	methods: {
		...mapActions("certificado", ["updateArrayCertificado"]),
		...mapActions("certificado", ["updateArrayInstanciaCertificado"]),
		...mapActions("curso", ["updateOnlyCurso"]),
		modalCertificado(dataCertificado) {
			this.$refs.viewCertificado.getInfoModal(dataCertificado.row);
		},
		getCertificadoInstancia() {
			this.axios.get("api/getCertificadosCoordinadora").then((res) => {
				this.updateArrayInstanciaCertificado(res.data.certificados);
			});
		},
		modalOpcion(arrayOpcion) {
			this.$refs.editCertificado.getInfoModal(arrayOpcion.row);
		},
		modalEditCurso(cursos) {
			this.$refs.editCursoCertificado.getInfoModal(cursos);
		},
		getCursoCoordinadora() {
			this.axios
				.get("api/getCursoCoordinadora")
				.then((res) => {
					const listadoCursos = res.data.listadoCursos;

	/* 			 	const cursosCoordinadora = listadoCursos.map((elem) => ({
						idCurso: elem.idCurso,
						tituloCurso: `#${elem.idCurso} ${elem.tituloCurso}`,
					})); */

					this.updateOnlyCurso(listadoCursos); 
				})
				.catch((err) => console.log(err));
		},
		checkPrivilegio(idPrograma) {


			const dataCertificado = this.jsonCoordinadora.privilegios.find(
				(x) => x.idPrograma == idPrograma
			);

			return dataCertificado.certificado === 1 ? true : false;
		},
	},
	created() {
		this.getCertificadoInstancia();
		this.getCursoCoordinadora();
	},
};
</script>
